import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="dynamic-sticky"
export default class extends Controller {
  static targets = ["top"]
  connect() {
    this.setup()
  }

  setup() {
    this.observer = new ResizeObserver(() => this.updatePositions())
    this.topTargets.forEach(target => this.observer.observe(target))
  }

  topTargetConnected(target) {
    this.observer?.observe(target)
  }

  topTargetDisconnected(target) {
    this.observer?.unobserve(target)
  }

  updatePositions() {
    this.topTargets.reduce((acc, target) => {
      target.style.top = `${acc}px`
      return acc + target.clientHeight
    }, 0)
  }
}
